import React from 'react';
import styles from './FeatureCard.module.css';

// A "why Ovalview" / "and there's more" card: an illustration well over a text block.
const FeatureCard = ({title, illustration, dark, span, children}) => (
    <article
        className={`${styles.card} ${dark ? styles.dark : ''}`}
        style={span ? {gridColumn: `span ${span}`} : undefined}
    >
        <div className={`${styles.well} ${dark ? styles.wellDark : ''}`}>{illustration}</div>
        <div className={styles.body}>
            <h3 className={styles.title}>{title}</h3>
            {children}
        </div>
    </article>
);

export default FeatureCard;
